import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { IGroupedRecognitions, IRecognitionData } from 'src/app/interfaces/IRecognitions';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { RecognitionsService } from 'src/app/services/recognitions/recognitions.service';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
import { IonSlides, Platform } from '@ionic/angular';

const STATE_ACTIVATED = {
  received: "received",
  granted: "granted"
}

@Component({
  selector: 'app-recognitions',
  templateUrl: './recognitions.page.html',
  styleUrls: ['./recognitions.page.scss'],
})
export class RecognitionsPage implements OnInit {

  @ViewChild('slides') slides: IonSlides;
  StateActivated = STATE_ACTIVATED.received;
  states = STATE_ACTIVATED;
  recognitions = [];
  recognitionsGrouped = [];
  LOADER_ID = 'recognitions';
  slidesContentPerView = 3;
  getScreenWidth: any;
  getScreenHeight: any;
  slidesOptions = {
    initialSlide: 0,
    direction: 'horizontal',
    speed: 300,
    spaceBetween: 8,
    slidesPerView: 3,
    freeMode: false,
    loop: false
  };

  constructor(
    private recognitionsService: RecognitionsService,
    private loaderService: LoaderService,
    private remoteConfig: RemoteConfigService,
    private platform: Platform  ) {
    this.getReceivedRecognitions();
    this.getGroupedRecognitions();
  }

  ngOnInit() {
    this.getReceivedRecognitions();
    this.getGroupedRecognitions();

    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;

    if(this.getScreenWidth < 1200){
      this.slidesContentPerView = 3;
    } else {
      this.slidesContentPerView = 5;
    }

    this.slidesOptions = {
      initialSlide: 0,
      direction: 'horizontal',
      speed: 300,
      spaceBetween: 8,
      slidesPerView: this.slidesContentPerView,
      freeMode: false,
      loop: false
    };
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;
    if(this.getScreenWidth < 1200){
      this.slidesContentPerView = 3;
    } else {
      this.slidesContentPerView = 5;
    }

    this.slidesOptions = {
      initialSlide: 0,
      direction: 'horizontal',
      speed: 300,
      spaceBetween: 8,
      slidesPerView: this.slidesContentPerView,
      freeMode: false,
      loop: false
    };
  }

  async filterState(state) {
    this.recognitions = [];
    this.StateActivated = state;
    this.loaderService.presentLoading(this.LOADER_ID);
    if(state == 'received'){
      this.getReceivedRecognitions();
      this.getGroupedRecognitions();
    } else {
      this.getGrantedRecognitions();
      this.getGroupedGrantedRecognitions();
    }
  }

  clearFilters(){
    if(this.StateActivated == 'received'){
      this.getReceivedRecognitions();
      this.getGroupedRecognitions();
    } else {
      this.getGrantedRecognitions();
      this.getGroupedGrantedRecognitions();
    }
  }

  getReceivedRecognitions(){   
    this.recognitionsService.getReceivedRecognitions().then((res: IRecognitionData) => {
      this.recognitions = res.data.sort((a, b) => Number(new Date(b.datetime)) - Number(new Date(a.datetime)));
      this.loaderService.cancelLoader(this.LOADER_ID);
    })
  }

  getGroupedRecognitions(){    
    this.recognitionsService.getGroupedRecognitions().then((res: IGroupedRecognitions) => {
      this.recognitionsGrouped = res.data;
      this.loaderService.cancelLoader(this.LOADER_ID);
    })
  }

  getGroupedGrantedRecognitions(){    
    this.recognitionsService.getGroupedGrantedRecognitions().then((res: IGroupedRecognitions) => {
      this.recognitionsGrouped = res.data;
      this.loaderService.cancelLoader(this.LOADER_ID);
    })
  }

  getGrantedRecognitions(){
    this.recognitionsService.getGrantedRecognitions().then((res: IRecognitionData) => {
      this.recognitions = res.data.sort((a, b) => Number(new Date(b.datetime)) - Number(new Date(a.datetime)));
      this.loaderService.cancelLoader(this.LOADER_ID);
    })
  }

  seeNote(index, element){
    const note = document.querySelector('#card-note-'+index) as HTMLElement;
    note.style.display = note.style.display == 'none' || note.style.display == '' ? 'block' : 'none';
    element.target.innerHTML = element.target.innerHTML == 'Leer más' ? 'Leer menos': 'Leer más';
  }

  getGroupedRecognitionsFilter(recognitions){
    this.recognitions = recognitions.sort((a, b) => Number(new Date(b.datetime)) - Number(new Date(a.datetime)));
  }

  next() {
    this.slides.slideNext();
  }

  prev() {
    this.slides.slidePrev();
  }

}
